import React, { useState } from 'react';
import { Drawer, List, ListItem, ListItemText, IconButton, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArticleStore from './Article-store';

interface NavigationItem {
    label: string;
    text: string;
    href: string;
}

interface SideNavigationProps {
    isMobile: boolean;
    onSelect: (value: string) => void;
}

const SideNavigation: React.FC<SideNavigationProps> = ({ isMobile, onSelect }) => {
    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState('');

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const navigationItems: NavigationItem[] = [
        { label: 'All Members', text: '', href: '' },
        ...ArticleStore.membersNames.map((memberName: string) => ({ label: memberName, text: memberName, href: '' }))
      ];
      

    const handleSelect = (value: string) => {
        setSelectedItem(value);
        onSelect(value); // Pass the selected value to the parent component
    };

    return (
        <>

            <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={toggleDrawer}
            >
                <ArrowBackIosIcon style={{ fontSize: 'medium', marginBottom: '10px' }} />
                <Typography style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                    Select Member
                </Typography>
            </IconButton >

            <Drawer
                variant={isMobile ? 'temporary' : 'temporary'}
                anchor="left"
                open={open}
                onClose={toggleDrawer}
                style={{ height: '50vh', overflowY: 'auto' }}
            >
                <Typography style={{ fontWeight: 'bold', marginTop: '10px', textAlign:"center" }}>
                    Select Member
                </Typography>
                <List>
                    {navigationItems.map((item, index) => (
                        <ListItem 
                        button 
                        key={index}
                        sx={{ backgroundColor: item.text === selectedItem ? '#F0C1C1' : 'inherit' }}
                        onClick={() => {
                            handleSelect(item.text);
                            toggleDrawer();
                        }}>
                            <ListItemText primary={item.label} />
                        </ListItem>
                    ))}
                </List>
            </Drawer>
        </>
    );
};

export default SideNavigation;